import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de555632"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "card bg-light mb-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-plus-circle me-2" }),
  /*#__PURE__*/_createTextVNode("เพิ่มเขตตรวจราชการ ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-arrows-alt me-2" }, null, -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-md-6" }, " ", -1))
const _hoisted_7 = { class: "col-sm-12 col-md-6" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-auto col-form-label m-0 p-0" }, "ค้นหา:", -1))
const _hoisted_10 = { class: "col" }
const _hoisted_11 = {
  key: 0,
  class: "card card-empty my-2"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body d-flex justify-content-center align-items-center text-danger" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }),
  /*#__PURE__*/_createTextVNode("ไม่พบข้อมูล ")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "card-body d-flex align-items-center" }
const _hoisted_15 = { class: "row w-100" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "no-bullets" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-sign me-2" }, null, -1))
const _hoisted_19 = { class: "d-flex justify-content-start wraper" }
const _hoisted_20 = {
  key: 0,
  class: "col-auto d-flex align-items-center"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-edit me-2" }, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "col-md-4 col-xl-3"
}
const _hoisted_24 = { class: "card bg-light" }
const _hoisted_25 = { class: "card-header" }
const _hoisted_26 = { class: "input-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-search" })
], -1))
const _hoisted_28 = { class: "card-body p-0" }
const _hoisted_29 = { class: "list-group list-group-flush" }
const _hoisted_30 = {
  key: 0,
  class: "list-group-item bg-light text-center text-danger"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_32 = ["data-bs-content"]
const _hoisted_33 = ["onDragstart"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-sign mx-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_PaginateComponent = _resolveComponent("PaginateComponent")!
  const _component_PerfectScrollbar = _resolveComponent("PerfectScrollbar")!
  const _component_AppointmentRegionFormComponent = _resolveComponent("AppointmentRegionFormComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass({'col-md-8 col-xl-9': _ctx.appointmentStatus === 0})
      }, [
        (_ctx.appointmentStatus === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", {
                class: _normalizeClass(["card-body p-3 dropzone d-flex justify-content-center align-items-center", {drag: _ctx.isDrag}]),
                onDragover: _cache[0] || (_cache[0] = ($event: any) => ($event.preventDefault())),
                onDrop: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)), ["stop","prevent"]))
              }, [
                _hoisted_4,
                _createTextVNode("กรุณาลากชื่อเขตตรวจราชการด้านขวามือมาที่นี่ ")
              ], 34)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    "aria-label": "Search",
                    autocomplete: "off",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterAppointmentRegion.keyword) = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.filterAppointmentRegion.keyword,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.displayAppointmentRegions.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.displayAppointmentRegions, (appointmentRegion, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["card card-region my-2", {'card-region-active': _ctx.appointmentStatus === 0}])
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("ul", _hoisted_17, [
                                _createElementVNode("li", null, [
                                  _hoisted_18,
                                  _createTextVNode(_toDisplayString(appointmentRegion.region.name), 1)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("div", _hoisted_19, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointmentRegion.provinces, (province) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        class: "badge bg-primary rounded-pill mt-1 me-1",
                                        key: province.id
                                      }, _toDisplayString(province.name), 1))
                                    }), 128))
                                  ])
                                ])
                              ])
                            ]),
                            (_ctx.appointmentStatus === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createElementVNode("button", {
                                    class: "btn region-edit-btn",
                                    onClick: ($event: any) => (_ctx.editClick(appointmentRegion.id))
                                  }, [
                                    _hoisted_22,
                                    _createTextVNode("แก้ไข ")
                                  ], 8, _hoisted_21)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 2))
                    }), 128))
              ], 64)),
          _createVNode(_component_PaginateComponent, {
            "page-size": _ctx.page.size,
            amount: _ctx.filterAppointmentRegion.amount,
            total: _ctx.filterAppointmentRegion.total,
            onCurrentPageChange: _ctx.selectedPage
          }, null, 8, ["page-size", "amount", "total", "onCurrentPageChange"])
        ])
      ], 2),
      (_ctx.appointmentStatus === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    "aria-label": "Search",
                    autocomplete: "off",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterRegion.keyword) = $event))
                  }, null, 512), [
                    [
                      _vModelText,
                      _ctx.filterRegion.keyword,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_PerfectScrollbar, null, {
                  default: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_29, [
                      (_ctx.searchRegion.length === 0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                            _hoisted_31,
                            _createTextVNode("ไม่พบข้อมูล ")
                          ]))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.searchRegion, (region, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index,
                              class: _normalizeClass(["list-group-item p-0", {'ghost-region': _ctx.dragElement === region.id}]),
                              "data-bs-toggle": "popover-region",
                              "data-bs-content": region.name
                            }, [
                              _createElementVNode("div", {
                                class: "draggable text-truncate p-3",
                                draggable: "true",
                                onDragstart: ($event: any) => (_ctx.onDragStart($event, region.id.toString())),
                                onDragend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDragEnd && _ctx.onDragEnd(...args)))
                              }, [
                                _hoisted_34,
                                _createTextVNode(" " + _toDisplayString(region.name), 1)
                              ], 40, _hoisted_33)
                            ], 10, _hoisted_32))
                          }), 128))
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_AppointmentRegionFormComponent, {
      ref: "appointmentRegionForm",
      "appointment-region": _ctx.selectedAppointmentRegion,
      onClear: _ctx.clearSelectedAppointmentRegion
    }, null, 8, ["appointment-region", "onClear"])
  ], 64))
}